<cos-drawer-container class="drawer-container">
  <cos-drawer-content #content>
    @if (showPreviewFrame()) {
      @let t = 'customerPortalCommon.feature-header' | cosTranslationCtx;
      <div class="project-host__header">
        @if (routesData.visitedPage === 'order') {
          <span>{{ t('preview-order') }}</span>
        } @else if (routesData.visitedPage === 'quote') {
          <span>{{ t('preview-quote') }}</span>
        } @else if (routesData.visitedPage === 'invoice') {
          <span>{{ t('preview-invoice') }}</span>
        } @else if (previewService.isTemplatePreviewMode()) {
          <span>{{ t('preview-template') }}</span>
        } @else {
          <span>{{ t('preview-presentation') }}</span>
        }
      </div>
    }
    @if (vm().showHeader) {
      <customer-portal-new-header
        (menuResize)="menuResize($event)"
        [landingMode]="vm().landingMode"
        class="print:!hidden"
      />
    }
    <router-outlet />
    <div
      class="product-carousel-wrapper"
      [style.--product-carousel-mobile-offset.px]="headerHeight()"
    >
      <ng-container cosTeleportOutlet="productCarousel" />
    </div>
    @if (vm().showFooter) {
      <customer-portal-new-footer class="mt-auto" />
    }
  </cos-drawer-content>
  <cos-drawer mode="over" position="end" class="drawer">
    <div class="flex flex-column h-full w-full">
      <!-- Drawer content will be dynamically injected here -->
      <ng-container #drawerContent />
    </div>
  </cos-drawer>
</cos-drawer-container>
